
define(
    'C3.ShoppingExtensions.Carousel.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function CarouselModel() {
            SCModel.call(this);

            // Define properties of the model.
            /*this.urlRoot = function() {
                Utils.getAbsoluteUrl(
                    getExtensionAssetsPath(
                        "services/Carousel.Service.ss"
                    )
                )
            }*/

            this.url = function() {
                //return 'services/Carousel.Service.ss'
                return Utils.getAbsoluteUrl(
                    getExtensionAssetsPath(
                        "services/Carousel.Service.ss"
                    )
                )
            };
        }

        CarouselModel.prototype = Object.create(SCModel.prototype);

        CarouselModel.prototype.constructor = CarouselModel;

        // Return the AMD constructor.
        return CarouselModel;
    }
);
